var render = function render(){var _vm=this,_c=_vm._self._c;return _c('button',{staticClass:"cruise-slider-arrow tw-w-full tw-absolute tw-left-0 tw-z-2",class:[`cruise-slider-arrow--${_vm.arrowType}`],on:{"click":function($event){return _vm.$emit('click')}}})
}
var staticRenderFns = []

export { render, staticRenderFns }